import React, { FC } from "react";

interface LinearLoaderProps {

}

const LinearLoader: FC<LinearLoaderProps> = () => {
    return (<div className="linear-spinner">
        <div className="bar"></div>
    </div>);
}

export default LinearLoader;